import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const JenisKegiatan = () => {
    const columns = [
        {
            name: 'Kode Kegiatan',
            cell: row => row['kdKegiatan'] 
        },
        {
            name: 'Uraian Kegiatan',
            cell: row => row['nmKegiatan'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listJenisKegiatan, setlistJenisKegiatan] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistJenisKegiatan = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listJenisKegiatan(null, page, size)
            setlistJenisKegiatan(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistJenisKegiatan([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistJenisKegiatan(0, 10)
    }, [getlistJenisKegiatan])

    const handleChangePage = (page) => {
        getlistJenisKegiatan(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listJenisKegiatan(null, page - 1, size)
        setlistJenisKegiatan(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Jenis Kegiatan</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listJenisKegiatan}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default JenisKegiatan